import * as React from "react";
const SvgFullBar = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.778 8.795C.905 6.19 1.475 3.823 2.804.72a.746.746 0 0 1 .582-.461.748.748 0 0 1 .131-.009h5.966a.748.748 0 0 1 .713.47c.713 1.665 1.21 3.125 1.537 4.53H22.5a.75.75 0 0 1 .53 1.28l-6.78 6.78v6.265l4.636 2.782a.75.75 0 0 1-.386 1.393h-18a.75.75 0 0 1 0-1.5h3.293A.749.749 0 0 1 5.75 22v-6.785c-1.228-.115-2.372-.523-3.264-1.262C1.396 13.049.75 11.704.75 10c0-.289.005-.574.014-.855a.754.754 0 0 1 .014-.35Zm1.473.955H7.5a.75.75 0 0 0 0-1.5H2.316c.164-2.055.653-4.012 1.682-6.5h5.004c.53 1.284.916 2.422 1.188 3.5H8.5a.75.75 0 0 0-.53 1.28l2.77 2.77c.007.23.01.464.01.7 0 1.296-.474 2.202-1.193 2.798-.738.611-1.803.952-3.057.952s-2.32-.34-3.057-.952C2.724 12.202 2.25 11.296 2.25 10l.001-.25Zm12.499 9.825-4.458 2.675H7.207A.749.749 0 0 0 7.25 22v-6.785c1.228-.115 2.372-.523 3.264-1.262.922-.765 1.526-1.843 1.69-3.188l2.546 2.546v6.264ZM11.112 6.75h-.801l1.663 1.664a.76.76 0 0 1 .069.068L15.5 11.94l5.19-5.189h-9.578Zm6.68 15.5L15.5 20.875l-2.292 1.375h4.584Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgFullBar;
